<div class="notifications-dropdown">
    <div class="dropdown-header">
        <h3>Notifications</h3>
        <div class="header-actions">
            <button
                class="time-toggle-btn"
                (click)="toggleTimeDisplay()"
                [title]="showExactTime ? 'Show relative time' : 'Show exact time'"
            >
                <mat-icon>{{ showExactTime ? 'schedule' : 'access_time' }}</mat-icon>
            </button>

            <button class="more-actions-btn" [matMenuTriggerFor]="actionsMenu" title="More actions">
                <mat-icon>more_vert</mat-icon>
            </button>

            <mat-menu #actionsMenu="matMenu" xPosition="before">
                <button mat-menu-item (click)="onMarkAllAsRead()">
                    <mat-icon>done_all</mat-icon>
                    <span>Mark All as Read</span>
                </button>
                <button mat-menu-item (click)="onClearAllNotifications()">
                    <mat-icon>clear_all</mat-icon>
                    <span>Clear All Notifications</span>
                </button>
            </mat-menu>
        </div>
    </div>

    <div
        class="notifications-content"
        #scrollContainer
        (scroll)="onScroll($event)"
        (click)="resetSwipeState()"
    >
        @if (isLoading$ | async) {
            @if ((groupedNotifications$ | async)?.length === 0) {
                <div class="loading-indicator">
                    <mat-spinner diameter="40"></mat-spinner>
                </div>
            } @else {
                <div class="h-[2px] overflow-hidden w-full">
                    <mat-progress-bar mode="indeterminate" />
                </div>
            }
        }

        @for (group of groupedNotifications$ | async; track group.date) {
            <div class="date-header sticky">
                {{ formatDate(group.date) }}
            </div>

            @for (notification of group.notifications; track notification._id) {
                <div class="notification-item-container">
                    <!-- Delete Button (Hidden Behind) -->
                    <div class="notification-delete-background">
                        <button
                            class="delete-btn"
                            (click)="onDeleteNotification($event, notification._id)"
                            title="Delete notification"
                        >
                            <mat-icon>delete</mat-icon>
                        </button>
                    </div>

                    <!-- Swipeable Notification Content -->
                    <div
                        class="notification-item"
                        [class.read]="isNotificationRead(notification)"
                        [class.unread]="!isNotificationRead(notification)"
                        [class.clickable]="hasRoute(notification)"
                        [class.swiped]="swipedNotificationId === notification._id"
                        [style.transform]="getNotificationTransform(notification._id)"
                        (mousedown)="onSwipeStart($event, notification._id)"
                        (touchstart)="onSwipeStart($event, notification._id)"
                        (click)="onNotificationClick(notification)"
                    >
                        <div class="notification-wrapper">
                            <div class="notification-image">
                                @if (notification.icon) {
                                    <img
                                        [src]="notification.icon"
                                        [alt]="notification.title"
                                        class="notification-img"
                                    />
                                } @else {
                                    <div class="notification-placeholder">
                                        <mat-icon>notifications</mat-icon>
                                    </div>
                                }
                            </div>
                            <div class="notification-content">
                                <div class="notification-header">
                                    <h4 class="notification-title leading-tight">
                                        {{ notification.title }}
                                    </h4>
                                    <div class="notification-meta">
                                        <span
                                            class="notification-time"
                                            [class.exact-time]="showExactTime"
                                        >
                                            {{ getDisplayTime(notification.createdAt) }}
                                        </span>
                                    </div>
                                </div>
                                <p class="notification-body">{{ notification.body }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            }
        }

        @if (isLoadingMore$ | async) {
            <div class="flex justify-center items-center py-4">
                <mat-spinner diameter="24"></mat-spinner>
            </div>
        }

        @if ((hasNextToken$ | async) === false && (isLoading$ | async) === false) {
            <div class="end-message">No more notifications</div>
        }
    </div>
</div>
